import React from 'react';
import { Button } from '@mui/material';
import T, { bool, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { NotifyTypo } from 'web-components';
import { useDispatch } from 'react-redux';
import { deleteAlarmConfig, deleteErrorCode } from '../../../../../redux/machines/actions';
import { StyledHandlers } from '../../elements';
import { StyledContent, StyledNewDialog } from '../elements';
import { isIrisInsideVariant } from 'attrs/plcConfigValues';

const labelAmend = 'machines.machine_details.delete_modal';

const DeleteSensor = ({ open, handleClose, machineId, errorId, plcType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const errorToastProps = {
    variant: 'error',
    autoHideDuration: 3000
  };

  const handleDeleteSensor = async () => {
    try {
      if (isIrisInsideVariant(plcType)) {
        dispatch(deleteAlarmConfig(machineId, errorId));
      } else {
        dispatch(deleteErrorCode(machineId, errorId));
      }
      handleClose(true);
    } catch (error) {
      if (error.response && error.response.status === 500) {
        enqueueSnackbar(t('machines.generic_error'), errorToastProps);
      }
    }
  };

  const actionBar = (
    <StyledHandlers>
      <Button color="secondary" onClick={() => handleClose()}>
        {t(`${labelAmend}.cancel`)}
      </Button>
      <Button
        variant="contained"
        data-testid="license-modal-submit"
        style={{ padding: '1rem 2.5rem' }}
        color="error"
        onClick={handleDeleteSensor}
      >
        {t(`${labelAmend}.action`)}
      </Button>
    </StyledHandlers>
  );

  return (
    <StyledNewDialog
      open={open}
      handleClose={(event, reason) => {
        if (reason && reason === 'backdropClick') return;
        handleClose();
      }}
      title={t(`${labelAmend}.error_code_title`)}
      subTitle={t(`${labelAmend}.error_code_subtitle`)}
      displayActionBar="true"
      actionBar={actionBar}
      maxWidth="680px"
      content={
        <StyledContent>
          <NotifyTypo.Heading2>{t(`${labelAmend}.error_code_text`)}</NotifyTypo.Heading2>
        </StyledContent>
      }
    />
  );
};

DeleteSensor.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
  machineId: T.string.isRequired,
  errorId: T.string.isRequired,
  plcType: T.string.isRequired
};

export default DeleteSensor;
